import "./App.css";
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1 className="text-center">Dictionary</h1>
      </header>
      <div className="App-body">
        <main>
          <Dictionary />
        </main>
        <footer className="text-center pb-5">
          <small>
            Coded by Sabrina Onishi, open-sourced on{" "}
            <a
              href="https://github.com/So0703/react-dictionary-project"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>{" "}
            and hosted on{" "}
            <a href="https://www.netlify.com/" target="_blank" rel="noreferrer">
              Netlify
            </a>{" "}
          </small>
        </footer>
      </div>
    </div>
  );
}
